import { render, staticRenderFns } from "./ManageGroup.vue?vue&type=template&id=4983aad9&scoped=true&"
import script from "./ManageGroup.vue?vue&type=script&lang=js&"
export * from "./ManageGroup.vue?vue&type=script&lang=js&"
import style0 from "./ManageGroup.vue?vue&type=style&index=0&id=4983aad9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983aad9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4983aad9')) {
      api.createRecord('4983aad9', component.options)
    } else {
      api.reload('4983aad9', component.options)
    }
    module.hot.accept("./ManageGroup.vue?vue&type=template&id=4983aad9&scoped=true&", function () {
      api.rerender('4983aad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/ManageGroup.vue"
export default component.exports